import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { CA } from "../config";

export default function ContractCard({ compact = false }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(CA);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = CA;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    toast.success("Contract copied — Santa approves.");
    setTimeout(() => setCopied(false), 2200);
  };

  if (compact) {
    return (
      <button
        data-testid="footer-copy-ca-button"
        onClick={copy}
        className="group inline-flex max-w-full items-center gap-2 rounded-xl border border-white/10 bg-white/[0.04] px-4 py-2 font-mono-x text-xs text-slate-300 transition-colors duration-200 hover:border-[#00F5D4]/40 hover:text-[#00F5D4]"
      >
        <span className="truncate">CA: {CA}</span>
        {copied ? <Check className="h-3.5 w-3.5 shrink-0 text-[#00E676]" /> : <Copy className="h-3.5 w-3.5 shrink-0" />}
      </button>
    );
  }

  return (
    <div
      data-testid="contract-card"
      className="rounded-2xl border border-white/10 bg-[#0F141C]/80 p-4 shadow-[0_8px_32px_rgba(0,0,0,0.4)] backdrop-blur-xl sm:p-5"
    >
      <div className="flex flex-col items-center gap-4 sm:flex-row">
        <div className="w-full min-w-0 flex-1 text-center sm:text-left">
          <p className="mb-1 font-mono-x text-[10px] uppercase tracking-[0.3em] text-slate-500">$SOLMAS Contract Address</p>
          <p data-testid="contract-address-text" className="break-all font-mono-x text-xs text-[#00F5D4] sm:text-sm">
            {CA}
          </p>
        </div>
        <button
          data-testid="copy-contract-button"
          onClick={copy}
          className="inline-flex shrink-0 items-center gap-2 rounded-xl bg-gradient-to-r from-[#FF2B4A] to-[#FF5252] px-6 py-3 font-display text-sm font-bold text-white shadow-[0_0_20px_rgba(255,43,74,0.4)] transition-all duration-200 hover:scale-[1.03] hover:shadow-[0_0_30px_rgba(255,43,74,0.7)] active:scale-[0.97]"
        >
          {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
          {copied ? "Copied" : "Copy CA"}
        </button>
      </div>
    </div>
  );
}
